import styled from 'styled-components';

export const DeadlinesWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(25,51,77,0.06);
`;

export const DeadlinesTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: #223046;
  margin: 4px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DeadlineList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DeadlineCard = styled.div<{ $urgent?: boolean }>`
  background: ${({ $urgent }) => ($urgent ? '#FFF3F3' : '#F8FAFC')};
  border: 1.5px solid ${({ $urgent }) => ($urgent ? '#FAD7D7' : '#E7EAEE')};
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DeadlineInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DeadlineName = styled.div`
  color: #223046;
  font-weight: 600;
`;

export const Pill = styled.span`
  background: #F3F4F6;
  color: #223046;
  font-size: 0.8rem;
  font-weight: 700;
  border-radius: 6px;
  padding: 2px 8px;
  margin-left: 8px;
`;

export const DueDate = styled.span`
  color: #6B7280;
  font-size: 0.95rem;
`;

export const ViewAllButton = styled.button`
  margin-top: 10px;
  width: 100%;
  background: #FFFAF1;
  color: #223046;
  border: 1.5px solid #F7E6C3;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
`;


